<template>
  <div>
    <div class="img-item" :style="styles">
      <div class="addimg-select" @click="openUpload" v-if="!form.file_path"><i class="el-icon-plus"></i></div>
      <div class="item">
      <el-image class="imgw100" :style="styles" :src="form.file_path" :fit="fit?fit:'cover'" lazy :preview-src-list="[form.file_path]" alt="" v-if="form.file_path" />
        <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg" v-if="form.file_path"><i class="el-icon-close"></i></a>
      </div>
    </div>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
  </div>
</template>

<script>
import Upload from '@/components/file/Upload';
export default {
  components: {
    Upload,
  },
  data() {
    return {
      form: {
        file_id: '',
        file_path: '',
      },
      loading: false,
      isupload: false,
    };
  },
  props: ['config', 'image', 'styles', 'fit'],
  created() {
    if (this.image) this.form = this.image;
  },
  watch: {
    image: function(n, o) {
      if (n != o) this.form = n;
    },
  },
  methods: {
    /*上传*/
    openUpload() {
      this.isupload = true;
    },
    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null) {
        this.form.file_id = e[0].file_id;
        this.form.file_path = e[0].file_path;
        this.$emit('return', this.config, this.form);
      }
      this.isupload = false;
    },
    /*删除商品图片*/
    deleteImg() {
      this.form.file_id = '';
      this.form.file_path = '';
    },

  },
};
</script>



// WEBPACK FOOTER //
// src/components/image/Single.vue